import React from 'react';
import PropTypes from 'prop-types';
import { InvisibleButton } from './styled';

export const CloseButton = ({
  onClick, size, style: passedStyle, ...rest
}) => {
  if (!onClick) {
    return null;
  }
  const style = {
    width: `${size}px`,
    height: `${size}px`,
    ...passedStyle
  };
  return (
    <InvisibleButton onClick={onClick} style={style} {...rest}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <g
          fill="none"
          fillRule="evenodd"
          stroke="#333"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M.727 0l13.818 15.2M15.273 0L1.455 15.2" />
        </g>
      </svg>
    </InvisibleButton>
  );
};

CloseButton.propTypes = {
  onClick: PropTypes.func,
  size: PropTypes.number,
  style: PropTypes.object
};

CloseButton.defaultProps = {
  onClick: null,
  size: 16,
  style: {}
};

export default CloseButton;
